/* eslint-disable react-hooks/rules-of-hooks */
// add filter table
import * as React from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Box,
  Tfoot,
  TableContainer,
  Badge,
} from "@chakra-ui/react";
import { TriangleDownIcon, TriangleUpIcon } from "@chakra-ui/icons";
import {
  useReactTable,
  flexRender,
  getCoreRowModel,
  ColumnDef,
  SortingState,
  getSortedRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
} from "@tanstack/react-table";
import { useColorModeValue } from "@chakra-ui/react";
import ButtonComponents from "../Form/Button";
import Filter from "./Filter";
import SelectForm from "../Form/SelectForm";
import TextComponent from "../Form/Text";
import FormControlDefaultComponent from "../Form/FormControlDefault";
import DatePicker from "react-datepicker";

export type DataTableProps<Data extends object> = {
  data: Data[];
  columns: ColumnDef<Data, any>[];
  edit: any;
  onOpenUpdate: any;
  setArray: any;
  total?: boolean;
  ExportExcel?: any;
  size?: string;
};

export function DataTable<Data extends object>({
  data,
  columns,
  edit,
  onOpenUpdate,
  setArray,
  total = false,
  ExportExcel = () => {},
  size = "",
}: DataTableProps<Data>) {
  const [sorting, setSorting] = React.useState<SortingState>([]);
  const table = useReactTable({
    columns,
    data,
    getCoreRowModel: getCoreRowModel(),
    onSortingChange: setSorting,
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    state: {
      sorting,
    },
  });
  const [dateRange, setDateRange] = React.useState(null);

  const dinero = (value: number) => {
    return new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
    }).format(value);
  };

  console.log("data", dateRange);

  return (
    <>
      <TableContainer>
        <Table variant="striped" colorScheme="gray" size="md">
          <Thead
            borderBottom="2px solid"
            borderBottomColor="#f06e26"
            style={{
              backgroundColor: "#f3f3f3",
            }}
          >
            {table.getHeaderGroups().map((headerGroup) => (
              <Tr key={headerGroup.id}>
                {headerGroup.headers.map((header: any) => {
                  const meta: any = header.column.columnDef.meta;
                  return (
                    <Th
                      key={header.id}
                      isNumeric={meta?.isNumeric}
                      color={useColorModeValue("black", "black")}
                    >
                      <div
                      >
                        <Text
                          fontSize={14}
                          fontWeight={600}
                          textAlign={"center"}
                          marginTop={header.column.getCanFilter() ? "0px" : -30}
                          marginBottom={
                            header.column.getCanFilter() ? "5px" : 0
                          }
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                        </Text>
                      </div>

                      {header.column.getCanFilter() ? (
                        header.column.columnDef.header === "Fecha" ? (
                          <div>
                            <DatePicker
                              isClearable={true}
                              startDate={
                                header.column?.filterValue || dateRange
                              }
                              selected={header.column?.filterValue || dateRange}
                              onChange={(date: any) => {
                                setDateRange(date);
                                // formatear 2024-04-24
                                const startDate = date
                                  ? date.toLocaleDateString("en-CA")
                                  : "";
                                header.column.setFilterValue(startDate);
                              }}
                              placeholderText="Seleccione una fecha"
                              className="form-control"
                            />
                          </div>
                        ) : (
                          <div>
                            <Filter
                              column={header.column}
                              table={table}
                              size={size}
                            />
                          </div>
                        )
                      ) : null}
                    </Th>
                  );
                })}
                {edit && <Th></Th>}
              </Tr>
            ))}
          </Thead>
          {size === "" ? (
            <Tbody>
              <Tr></Tr>
              <Tr>
                <Td
                  colSpan={edit ? columns.length + 1 : columns.length}
                  textAlign={"end"}
                  style={{ backgroundColor: "#fff !important" }}
                  className="bg-white"
                >
                  <ButtonComponents
                    text="Reporte general"
                    color="#3aa817"
                    onClick={() => ExportExcel(data)}
                    size="sm"
                  />
                </Td>
              </Tr>
            </Tbody>
          ) : null}
          <Tbody>
            {table.getHeaderGroups().map((headerGroup) => (
              <Tr key={headerGroup.id}>
                {headerGroup.headers.map((header: any) => {
                  const meta: any = header.column.columnDef.meta;
                  return (
                    <Th
                      key={header.id}
                      isNumeric={meta?.isNumeric}
                      color={useColorModeValue("black", "black")}
                    >
                      <div
                      >
                        <Text
                          fontSize={14}
                          fontWeight={600}
                          textAlign={"center"}
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                        </Text>
                      </div>
                    </Th>
                  );
                })}
              </Tr>
            ))}
            {table.getRowModel().rows.map((row) => (
              <Tr key={row.id}>
                {row.getVisibleCells().map((cell) => {
                  const meta: any = cell.column.columnDef.meta;
                  const value: any = cell.getValue() ?? "";
                  const header = cell.column.columnDef.header;
                  if (header === "Prioridad") {
                    return (
                      <Td
                        key={cell.id}
                        isNumeric={meta?.isNumeric}
                        color={useColorModeValue("black", "black")}
                        fontSize={size === "" ? "20px" : "14px"}
                        padding={size === "" ? "15px" : "5px"}
                        textAlign={size === "" ? "center" : "center"}
                      >
                        {value === "Critico" ? (
                          <Badge
                            colorScheme="red"
                            size={"lg"}
                            variant="solid"
                            fontSize="0.8em"
                          >
                            {value}
                          </Badge>
                        ) : value === "Urgente" ? (
                          <Badge
                            colorScheme="yellow"
                            size={"lg"}
                            variant="solid"
                            fontSize="0.8em"
                          >
                            {value}
                          </Badge>
                        ) : value === "Normal" ? (
                          <Badge
                            colorScheme="green"
                            size={"lg"}
                            variant="solid"
                            fontSize="0.8em"
                          >
                            {value}
                          </Badge>
                        ) : (
                          <Badge
                            colorScheme="green"
                            size={"lg"}
                            variant="solid"
                            fontSize="0.8em"
                          >
                            {value}
                          </Badge>
                        )}
                      </Td>
                    );
                  } else if (header === "Estatus") {
                    return (
                      <Td
                        key={cell.id}
                        isNumeric={meta?.isNumeric}
                        color={useColorModeValue("black", "black")}
                        fontSize={size === "" ? "20px" : "14px"}
                        padding={size === "" ? "15px" : "5px"}
                        textAlign={size === "" ? "center" : "center"}
                      >
                        {value === "Creado" ? (
                          <Badge
                            colorScheme="blue"
                            size={"lg"}
                            variant="solid"
                            fontSize="0.8em"
                          >
                            {value}
                          </Badge>
                        ) : value === "Recibido" ? (
                          <Badge
                            colorScheme="blue"
                            size={"lg"}
                            variant="solid"
                            fontSize="0.8em"
                          >
                            {value}
                          </Badge>
                        ) : value === "En proceso" ? (
                          <Badge
                            colorScheme="orange"
                            size={"lg"}
                            variant="solid"
                            fontSize="0.8em"
                          >
                            {value}
                          </Badge>
                        ) : value === "Terminado" ? (
                          <Badge
                            colorScheme="gray"
                            size={"lg"}
                            variant="solid"
                            fontSize="0.8em"
                          >
                            {value}
                          </Badge>
                        ) : (
                          <Badge
                            colorScheme="gray"
                            size={"lg"}
                            variant="solid"
                            fontSize="0.8em"
                          >
                            {value}
                          </Badge>
                        )}
                      </Td>
                    );
                  }

                  return (
                    <Td
                      key={cell.id}
                      isNumeric={meta?.isNumeric}
                      color={useColorModeValue("black", "black")}
                      fontSize={size === "" ? "20px" : "14px"}
                      padding={size === "" ? "15px" : "5px"}
                      textAlign={size === "" ? "center" : "center"}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </Td>
                  );
                })}
                {/** add button */}
                {edit ? (
                  <Td textAlign={"center"}>
                    <ButtonComponents
                      color={useColorModeValue("#2f5941", "#711c3d")}
                      size="xs"
                      text="Ver"
                      onClick={() => {
                        setArray(row.original);
                        onOpenUpdate(row.original);
                      }}
                    />
                  </Td>
                ) : null}
              </Tr>
            ))}
          </Tbody>
          {total ? (
            <Tfoot>
              <Tr style={{ backgroundColor: "#f3f3f3", textAlign: "start" }}>
                <Th>Total</Th>
                <Th>
                  {table.getRowModel().rows.reduce((acc, row): any => {
                    const array: any = row.original;
                    return acc + parseInt(array?.cantidad);
                  }, 0)}
                </Th>
                <Th>
                  {dinero(
                    table.getRowModel().rows.reduce((acc, row): any => {
                      const array: any = row.original;
                      return acc + parseFloat(array?.precio);
                    }, 0)
                  )}
                </Th>
                <Th>
                  {dinero(
                    table.getRowModel().rows.reduce((acc, row): any => {
                      const array: any = row.original;
                      return acc + parseFloat(array?.total);
                    }, 0)
                  )}
                </Th>
              </Tr>
            </Tfoot>
          ) : null}
        </Table>
      </TableContainer>
      <Box
        display={"flex"}
        justifyContent="end"
        alignItems={"center"}
        gap={5}
        mt={5}
      >
        <TextComponent
          text={`Pagina ${
            table.getState().pagination.pageIndex + 1
          } de ${table.getPageCount()}`}
          color="#000"
          fontSize={"15px"}
          fontWeight="600"
          textAlign={"center"}
        />

        {table.getCanPreviousPage() && (
          <ButtonComponents
            color={useColorModeValue("#f06e26", "#711c3d")}
            onClick={() => table.setPageIndex(0)}
            size="sm"
            text="<<"
            borderRadius="10px"
          />
        )}
        <ButtonComponents
          color={useColorModeValue("#f06e26", "#711c3d")}
          onClick={() => table.previousPage()}
          size="sm"
          text="<"
          borderRadius="10px"
        />
        <ButtonComponents
          color={useColorModeValue("#f06e26", "#711c3d")}
          onClick={() => table.nextPage()}
          size="sm"
          text=">"
          borderRadius="10px"
        />
        <ButtonComponents
          color={useColorModeValue("#f06e26", "#711c3d")}
          onClick={() => table.setPageIndex(table.getPageCount() - 1)}
          size="sm"
          text=">>"
          borderRadius="10px"
        />

        <Box mt={5}>
          <FormControlDefaultComponent
            label=""
            helperText="Ir a la pagina"
            type="text"
            placeholder="Ir a la pagina"
            defaultValue={table.getState().pagination.pageIndex + 1}
            onChange={(e) => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0;
              table.setPageIndex(page);
            }}
          />
        </Box>

        <Box>
          <SelectForm
            helperText=""
            placeholder="Seleccione una opcion"
            label=""
            value={table.getState().pagination.pageSize}
            onChange={(e) => {
              table.setPageSize(Number(e.target.value));
            }}
          >
            {[5, 10, 20, 30, 40, 50, 100].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Mostrar {pageSize}
              </option>
            ))}
          </SelectForm>
        </Box>
      </Box>
    </>
  );
}
